import AgencyHelper from 'features/Agency/agencyHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';

DialogVoucherDetailView.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object,
  onCancel: PropTypes.func,
  handleShowTransactionList: PropTypes.func,
};

function DialogVoucherDetailView({ item, onDone, user, handleShowTransactionList = () => { } }) {
  // MARK: ---- PROPERTIES ----
  const row = item;

  return (
    <div className="p-4">
      <div style={{ backgroundColor: AppColors.gray[100] }}>
        {UIHelper.buildSectionCard(
          <div
            className=""
            style={{
              backgroundColor: 'white',
              borderRadius: '5px',
              overflow: 'hidden',
            }}
          >
            {UIHelper.buildCardCellItem(
              'Mã voucher',
              row?.voucherCode ?? row?.voucherId ? `VC${row?.voucherId?.toString().padStart(8, '0')}` : '',
            )}
            {UIHelper.buildCardCellItem(
              'Mã lô voucher',
              row?.voucherBatchCode ?? row?.voucherBatchId ? `VP${row?.voucherBatchId?.toString().padStart(8, '0')}` : '',
              () => {
                Utils.openInNewTab(`${AppRoute.voucherBatchList}/${row?.voucherBatchId}`)
              }
            )}
            {UIHelper.buildCardCellItem(
              'Mã sử dụng',
              row?.voucherCode,
            )}
            {UIHelper.buildCardCellItem(
              'Tên khách hàng',
              row?.driver?.fullname,
              () => {
                Utils.openInNewTab(`${AppRoute.customerList}/${row?.driver?.userId}`)
              }
            )}
            {UIHelper.buildCardCellItem(
              'Số khung xe',
              row?.vehicle?.vinNumber,
              () => {
                Utils.openInNewTab(`${AppRoute.vehicleList}/${row?.vehicle?.vehicleId}`)
              }
            )}
            {UIHelper.buildCardCellItem(
              'Loại voucher',
              AgencyHelper.Utils.getVoucherTypeName(row?.type),
            )}
            {UIHelper.buildCardCellItem(
              'Giá trị voucher',
              Utils.formatNumber(row.value ?? 0),
            )}
            {UIHelper.buildCardCellItem(
              'Giá trị đã sử dụng',
              Utils.formatNumber((row.value - row.remainValue) ?? 0),
            )}
            {UIHelper.buildCardCellItem(
              'Số lần đã sử dụng',
              row?.usedCount,
            )}
            {UIHelper.buildCardCellItem(
              'Phiên sạc sử dụng voucher',
              item?.transactions?.length ? `Danh sách phiên sạc (${item?.transactions?.length})` : '',
              () => {
                handleShowTransactionList(item?.transactions)
              }
            )}
            {UIHelper.buildCardCellItem(
              'Ngày phát hành',
              row.releasedAt ? Utils.formatDateTimeToString(row.releasedAt, 'DD/MM/YYYY') : '',
            )}
            {UIHelper.buildCardCellItem(
              'Ngày hết hạn',
              row.expiredAt ? Utils.formatDateTimeToString(row.expiredAt, 'DD/MM/YYYY') : '',
            )}
            {UIHelper.buildCardCellItem(
              'Trạng thái',
              <KTLabel
                text={AgencyHelper.Utils.getVoucherStatusName(row.status)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${AgencyHelper.Utils.getVoucherStatusColor(row.status)}`}
              />
            )}
            {UIHelper.buildCardCellItem(
              'Người tạo',
              row?.creator?.fullname,
            )}
            {UIHelper.buildCardCellItem(
              'Ngày tạo',
              Utils.formatDateTimeToString(row.createdAt, 'DD/MM/YYYY - HH:mm'),
              null,
              false
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default DialogVoucherDetailView;
